import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useAppState } from "main/context/app-context";
import { navItems } from "utils/nav-items";
import { mapMenusToNavItems, NavItem } from "utils/menu-mapper";
import Close from "assets/icons/close.svg";
import ArrowDown from "assets/icons/arrow-down.svg";
import {
  BackDrop,
  CloseButton,
  DrawerContainer,
  DrawerHeader,
  DrawerNavMenu,
  DrawerNavMenuItem,
  DrawerNavMSubMenuContainer,
} from "./sideMenuDrawer.styles";

interface SideDrawerProps {
  onClose: () => void;
}

export const SideMenuDrawerComponent: React.FC<SideDrawerProps> = ({
  onClose,
}) => {
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const navigate = useNavigate();
  const { menus, menusError } = useAppState();

  // Mapear menus da API para NavItem, fallback para nav-items em erro/vazio
  const navigationItems: NavItem[] = React.useMemo(() => {
    if (menusError || !menus || menus.length === 0) {
      return navItems;
    }
    return mapMenusToNavItems(menus);
  }, [menus, menusError]);

  const goTo = (route: string, isExternal?: boolean) => {
    if (isExternal) {
      window.open(route, '_blank', 'noopener,noreferrer');
    } else {
      navigate(route);
    }
    onClose();
  };

  const handleTabClick = (item: NavItem, i: number) => {
    if (item.items) {
      if (i === activeItem) {
        setActiveItem(null);
        return;
      }
      setActiveItem(i);
      return;
    }
    goTo(item.route, item.isExternal);
  };

  return (
    <>
      <DrawerContainer>
        <DrawerHeader>
          <CloseButton onClick={() => onClose()}>
            <img src={Close} alt="" />
          </CloseButton>
        </DrawerHeader>
        <DrawerNavMenu>
          {navigationItems.map((item, i) => (
            <div key={item.label}>
              <DrawerNavMenuItem onClick={() => handleTabClick(item, i)}>
                {item.label} {item.items && <img src={ArrowDown} alt="" />}
              </DrawerNavMenuItem>
              {item.label && i === activeItem && (
                <DrawerNavMSubMenuContainer>
                  {item.items?.map((subItem) => (
                    <DrawerNavMenuItem
                      onClick={() => goTo(subItem.route, subItem.isExternal)}
                      key={subItem.label}
                    >
                      {subItem.label}
                    </DrawerNavMenuItem>
                  ))}
                </DrawerNavMSubMenuContainer>
              )}
            </div>
          ))}
        </DrawerNavMenu>
      </DrawerContainer>
      <BackDrop onClick={() => onClose()} />
    </>
  );
};
